import { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import InviteCodeForm from '../forms/InviteCodeForm';
import { resolveInviteCompany, removeInviteError } from '../../actions/user';
import { keycloakRegistrationFlagsSelector } from '../../helpers/selectors';
import { CHOOSER_STATE, getChooserState } from '../../helpers/ssoRegistrationFlow';
import { navigateToCreationPage } from '../../utils/utils';

/**
 * The single mobile-style "pick your company" screen body (PublicCompaniesActivity
 * mirror), shared by the flags screen and the company picker: the list of choices,
 * the invitation code beside it when the brand allows it, and an honest
 * "registration unavailable" message when there is nothing to offer at all.
 *
 * The wrappers pass the list (`items`, null while it is still loading) and how to
 * render it (`renderList`); the states, their layout and the invite handling live
 * here so both screens behave identically.
 */
class CompanyChooser extends Component {
  constructor(props) {
    super(props);
    this.handleInviteSubmit = this.handleInviteSubmit.bind(this);
  }

  handleInviteSubmit(data) {
    this.props.resolveInviteCompany(data.inviteCode).then((companyId) => {
      if (companyId) navigateToCreationPage(companyId);
    });
  }

  renderTitle() {
    return (
      <div className={this.props.titleClassName}>
        <FormattedMessage id="only.sso.select.company.select.title" />
      </div>
    );
  }

  renderInviteForm() {
    return (
      <InviteCodeForm
        onSubmit={this.handleInviteSubmit}
        onRetry={this.props.removeInviteError}
      />
    );
  }

  render() {
    const { items, allowInvite, renderList } = this.props;

    const renderers = {
      [CHOOSER_STATE.LOADING]: () => null,
      [CHOOSER_STATE.LIST]: () => (
        <>
          {this.renderTitle()}
          {renderList(items)}
          {allowInvite && this.renderInviteForm()}
        </>
      ),
      [CHOOSER_STATE.INVITE_ONLY]: () => (
        <>
          {this.renderTitle()}
          {this.renderInviteForm()}
        </>
      ),
      [CHOOSER_STATE.UNAVAILABLE]: () => (
        <>
          {this.renderTitle()}
          <div className="text-center mb-35">
            <FormattedMessage
              id="only.sso.register.unavailable"
              defaultMessage="Registration is not available for this service at the moment."
            />
          </div>
        </>
      )
    };

    return renderers[getChooserState(items, allowInvite)]();
  }
}

function mapStateToProps(state) {
  return {
    allowInvite: keycloakRegistrationFlagsSelector(state).allowRegisterWithInvitationCode
  };
}

const mapDispatchToProps = { resolveInviteCompany, removeInviteError };

export default connect(mapStateToProps, mapDispatchToProps)(CompanyChooser);
